import React, { useState } from 'react';

import { AddConference } from '../views/AddConference';
import { Button } from '@/components/v2/Button';
import { ConferencesTable } from '../components/ConferencesTable';
import { Conference, useGetAllConferences } from '../api/conferences';
import { EditConference } from '../views/EditConference';
import { Input } from '@/components/v2/Form/Input';
import useDebounce from '@oncolens/oncolens-ui/lib/hooks/common/useDebounce';
import { SortDescriptor } from 'react-stately';
import { SortDescriptorToApiParam } from '@/utils/sorting';
import { FaSearch } from 'react-icons/fa';

const ConferenceList = () => {
  const [queryValue, setQueryValue] = useState('');
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce((value: string) => setQueryValue(value), 500);
  const [sortDescriptor, setSortDescriptor] = useState<SortDescriptor>({
    column: 'CreatedDate',
    direction: 'descending',
  });
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetAllConferences(
    queryValue,
    SortDescriptorToApiParam(sortDescriptor),
  );
  const [isAddConference, setIsAddConference] = useState(false);
  const [isEditConference, setIsEditConference] = useState(false);
  const [selectedConference, setSelectedConference] = useState<Conference | null>(null);

  const handleEditConference = (conference: Conference) => {
    setSelectedConference(conference);
    setIsEditConference(true);
  };

  const addOrEditView = () => {
    if (isAddConference) {
      return <AddConference setIsAddConference={setIsAddConference} />;
    }
    if (isEditConference) {
      return (
        <EditConference
          setIsEditConference={setIsEditConference}
          conference={selectedConference as Conference}
        />
      );
    }
  };

  return (
    <div className="font-lato">
      <div className="flex flex-col justify-center my-3">
        {isAddConference || isEditConference ? (
          addOrEditView()
        ) : (
          <>
            <div className="mt-12 px-8 flex justify-between items-center">
              <div className="flex  text-zinc-800 items-center">
                <h1 className="text-2xl font-semibold">Conference</h1>
                <span className="text-2xl font-light">
                  , {data?.pages[0].pagination.totalCount} total
                </span>
              </div>
              <div className="flex gap-4">
                <div className="relative">
                  <Input
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      debouncedSearch(e.target.value);
                    }}
                    className="w-64 mt-0 flex-1 pl-8"
                    placeholder="Search by name or host organization"
                    data-cy="search-conference-input"
                  />
                  <FaSearch className="absolute left-2.5 top-2.5 text-zinc-400 z-10" />
                </div>
                <Button
                  variant="primary"
                  testId="add-conference-button"
                  onClickHandler={() => setIsAddConference(true)}>
                  Add conference
                </Button>
              </div>
            </div>
            <div className="w-full flex justify-center px-8 pb-20">
              <div className="bg-white shadow-sm px-2 border rounded-lg w-full mt-6">
                <ConferencesTable
                  data={data}
                  fetchNextPage={fetchNextPage}
                  hasNextPage={hasNextPage}
                  isFetchingNextPage={isFetchingNextPage}
                  handleEditConference={handleEditConference}
                  sortDescriptor={sortDescriptor}
                  onSortChange={setSortDescriptor}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConferenceList;
